import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import { getAuthorizationToken } from "../@velzon/utils/auth/index.js";
import useCurrentUser from "@velzon/Hooks/useCurrentUser.js";

const AuthProtected = (props) => {
  const user = useCurrentUser()
  // console.log('AuthProtected-> this component will call every time');
  const token = getAuthorizationToken()

  useEffect(() => {

  }, [])
  /*
    redirect is un-auth access protected routes via url
  */

  if (props.subscription && !user?.Job_seeker_details.is_subscribe) {
    return(<Navigate to={{ pathname: '/dashboard', state: { from: props.location } }} />)
  }
  if (!token) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };